<template>
  <div class="donations-container">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat class="futuristic-card">
          <v-container fluid class="pa-4 card-header">
            <h2 class="earth-color">ALL DONATIONS</h2>
            <div class="title-decoration"></div>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card flat class="futuristic-card">
          <v-container fluid class="pa-4">
            <v-text-field v-model="search"
                          label="Search Donations"
                          outlined
                          dense
                          class="futuristic-input"
                          prepend-inner-icon="mdi-magnify"
                          single-line
                          hide-details></v-text-field>
            <v-data-table :headers="columns"
                          :items="allDonations"
                          :search="search"
                          :items-per-page-options="[10, 25, { text: 'All', value: -1 }]"
                          :disable-initial-sort="true"
                          :loading="$loadingTrue"
                          class="futuristic-table">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template v-slot:items="props">
                <td>{{ formated_date_time(props.item.created_at) }}</td>
                <td>{{ props.item.title || 'N/A' }}</td>
                <td>{{ props.item.first_name }}</td>
                <td>{{ props.item.last_name }}</td>
                <td>{{ props.item.email || 'N/A' }}</td>
                <td>{{ props.item.phone_number || 'N/A' }}</td>
                <td>{{ props.item.payment_options }}</td>
                <td>{{ props.item.payment_method || 'N/A' }}</td>
                <td>{{ props.item.currency }}</td>
                <td>{{ Number(props.item.amount).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,") }}</td>
                <td class="status-cell">
                  <v-chip :color="getPaymentStatusColor(props.item.payment_status)"
                          text-color="white"
                          small
                          class="status-chip">
                    {{ props.item.payment_status }}
                  </v-chip>
                </td>
                <td>{{ formated_date_time(props.item.paid_at) }}</td>
                <td>
                  <router-link v-if="props.item.booking_ref_code"
                     :to="{ name: 'Booking', params: { booking_id: props.item.booking_public_id || props.item.booking_ref_code }}">
                    <u class="futuristic-link">{{ props.item.booking_ref_code }}</u>
                  </router-link>
                  <span v-else>-</span>
                </td>
                <td class="source-cell">
                  <v-chip v-if="props.item.donation_type == 1" color="indigo" text-color="white" small class="source-chip">
                    Booking
                  </v-chip>
                  <v-chip v-else color="grey lighten-2" text-color="black" small class="source-chip">
                    Normal
                  </v-chip>
                </td>
                <td>
                  <v-btn depressed
                         color="primary"
                         small
                         @click="viewDonation(props.item.public_id)"
                         class="futuristic-btn">
                    <v-icon left small>mdi-eye</v-icon>
                    View
                  </v-btn>
                </td>
              </template>
              <template v-slot:footer>
                <td :colspan="columns.length" class="footer-cell">
                  <vue-json-to-csv :json-data="allDonations"
                                   csv-title="Donations List"
                                   :labels="{
                                   title: { title: 'Title' },
                                   first_name: { title: 'First Name' },
                                   last_name: { title: 'SurName' },
                                   email: { title: 'Email' },
                                   phone_number: { title: 'Phone' },
                                   payment_options: { title: 'Donation To' },
                                   payment_method: { title: 'Payment Method' },
                                   currency: { title: 'Currency' },
                                   amount: { title: 'Amount' },
                                   payment_status: { title: 'Payment Status' },
                                   paid_at: { title: 'Paid Date' },
                                   booking_ref_code: { title: 'Booking Ref' },
                                   donation_type: { title: 'Donation Source' }
                                   }">
                    <v-btn depressed color="primary" class="futuristic-btn">
                      <v-icon left>mdi-download</v-icon>
                      Download CSV
                    </v-btn>
                  </vue-json-to-csv>
                </td>
              </template>
              <v-alert slot="no-results"
                       :value="true"
                       color="error"
                       icon="mdi-alert"
                       class="futuristic-alert">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import DonationsVuex from "../../../mixins/Computed/DonationVuex";
  import DateMixin from "../../../mixins/Functions/DateMixins";
  import VueJsonToCsv from "vue-json-to-csv";

  export default {
    components: { VueJsonToCsv },
    data() {
      return {
        search: "",
        columns: [
          { text: "Date", value: "created_at" },
          { text: "Title", value: "title" },
          { text: "First Name", value: "first_name" },
          { text: "Surname", value: "last_name" },
          { text: "Email", value: "email" },
          { text: "Phone", value: "phone_number" },
          { text: "Donation To", value: "payment_options" },
          { text: "Method", value: "payment_method" },
          { text: "Currency", value: "currency" },
          { text: "Amount", value: "amount" },
          { text: "Status", value: "payment_status" },
          { text: "Paid Date", value: "paid_at" },
          { text: "Booking Ref", value: "booking_ref_code" },
          { text: "Source", value: "donation_type" },
          { text: "Action", value: "" }
        ]
      };
    },
    created() {
      this.$store.dispatch("get_all_donations");
    },
    methods: {
      viewDonation(publicId) {
        this.$router.push({
          name: "Donation",
          params: { donation_id: publicId }
        });
      },
      getPaymentStatusColor(status) {
        switch (status) {
          case "Paid":
            return "#00c300";
          case "Deposit":
            return "#487eb0";
          case "Pending Payment":
            return "#cd201f";
          default:
            return "grey";
        }
      }
    },
    mixins: [DonationsVuex, DateMixin]
  };
</script>

<style scoped>
  .futuristic-card {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
  }
  .futuristic-card:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  }
  .card-header {
    background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
    padding: 16px;
  }
  .earth-color {
    color: #587e27;
    font-weight: 600;
    margin: 0;
  }
  .futuristic-search { max-width: 250px; }
  .futuristic-search >>> .v-input__slot { border-radius: 8px; background: #f5f7fa; }
  .futuristic-input >>> .v-input__slot { border-radius: 8px; background: #f5f7fa; }
  .futuristic-btn { border-radius: 8px; text-transform: none; font-weight: 500; transition: all 0.2s ease; }
  .futuristic-btn:hover { transform: translateY(-1px); box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); }
  .futuristic-table { border-radius: 8px; margin: 0 8px 8px; }
  .futuristic-table >>> table { border-collapse: separate; border-spacing: 0; }
  .futuristic-table >>> thead tr th { background: linear-gradient(45deg, #e8eaf6, #f5f7fa); color: #587e27; font-weight: 600; font-size: 13px; }
  .futuristic-table >>> tbody tr { transition: background-color 0.2s ease; }
  .futuristic-table >>> tbody tr:hover { background-color: #f5f7fa; }
  .futuristic-link { color: #19d238ff; text-decoration: none; font-weight: 500; }
  .futuristic-link:hover { color: #19d238ff; }
  .futuristic-alert { border-radius: 8px; margin: 8px; }
  @media (max-width: 960px) {
    .card-header { flex-direction: column; align-items: flex-start; padding: 12px; }
    .futuristic-search { max-width: 100%; margin-top: 12px; }
    .futuristic-table { margin: 0 4px 4px; }
    .futuristic-table >>> thead tr th { font-size: 12px; padding: 0 8px; }
    .futuristic-table >>> tbody tr td { font-size: 12px; padding: 0 8px; }
    .futuristic-btn { font-size: 0.9rem; }
  }
  @media (max-width: 600px) {
    .futuristic-card { border-radius: 6px; }
    .futuristic-btn { font-size: 0.85rem; }
    .futuristic-table { margin: 0 4px 4px; overflow-x: auto; }
    .futuristic-table >>> table { min-width: 700px; }
    .futuristic-table >>> thead { display: table-header-group; }
    .futuristic-table >>> tbody tr { display: table-row; }
    .futuristic-table >>> tbody tr td { display: table-cell; font-size: 0.85rem; padding: 6px 8px; }
    .futuristic-table >>> thead tr th { font-size: 0.85rem; padding: 6px 8px; }
  }
</style>